import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./reduxStore/store";
import "./App.css";
import FundPrices from "./pages/FundPrices/FundPrices";
import FundMarketNews from "./pages/FundMarketNews/FundMarketNews";
import AboutTheService from "./pages/AboutTheService/AboutTheService";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/fundPrices" />} />
          <Route path="/fundPrices" element={<FundPrices />} />
          <Route path="/fundMarketNews" element={<FundMarketNews />} />
          <Route path="/aboutTheService" element={<AboutTheService />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
